// 📁 src/api/walletMappingAPI.js


const API_BASE_URL = 'https://stage-apiv2.myearth.id'; // Replace with your backend base URL
//const API_BASE_URL = 'http://localhost:3030'; // Replace with your backend base URL

export const saveWalletMapping = async (issuer_id, wallet_id, name, email) => {
  try {
    const response = await fetch(`${API_BASE_URL}/wallet-mapping`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ issuer_id, wallet_id, name, email }),
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to save mapping');
    return result;
  } catch (err) {
    console.error("Mapping API Error:", err);
    return null;
  }
};

export const getWalletMappingsByIssuer = async (issuer_id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/wallet-mapping/${issuer_id}`);
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to fetch mappings');
    return result;
  } catch (err) {
    console.error("Fetch Mapping Error:", err);
    return [];
  }
};

export const sendEmailWithQRCode = async (email, qrData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/email/send-qr`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, qrData })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to send email');
    return result;
  } catch (err) {
    console.error("QR Email Send Error:", err);
    return null;
  }
};

export const getUserDetailsByEarthId = async (earthId) => {
  try {
    const response = await fetch(`https://stage-apiv2.myearth.id/user/getUser?earthId=${earthId}`, {
      method: 'GET'
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to fetch user');
    return result;
  } catch (err) {
    console.error("Get User Error:", err);
    return null;
  }
};

export const deleteUserByEarthId = async (earthId, publicKey) => {
  try {
    const response = await fetch(
      `https://stage-apiv2.myearth.id/user/deleteUser?earthId=${earthId}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ publicKey }),
      }
    );

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result?.message || 'Failed to delete user');
    }

    return result;
  } catch (error) {
    console.error('Delete User Error:', error);
    return null;
  }
};


// ✅ NEW: Delete wallet mapping by EarthID
export const deleteWalletMappingByEarthId = async (earthId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/wallet-mapping/delete/${earthId}`, {
      method: 'DELETE'
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to delete mapping');
    return result;
  } catch (err) {
    console.error("Delete Mapping Error:", err);
    return null;
  }
};


// ✅ Generate a UUID v4-style device ID
export function generateDeviceId() {
  return 'xxxxxxxxyxxxxyxxxyxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}
